var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',_vm._l((_vm.documentList),function(n){return _c('v-col',{key:`${n.sn}-content`},[_c('doc-upload',{attrs:{"apiUrl":n.apiUrl,"docTitle":n.docTitle,"file-size":"5","isPostAuthorized":_vm.isPostAuthorized,"show":false}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }